<template>
    <div class="post post-instagram" :class="{'response-comment' : responseComment}">
        <div class="detail-event-header no-border">
            <AvatarComponent :typeNetwork="currentPage.network" :urlPicture="currentPage.avatar" v-if="currentPage"></AvatarComponent>
            
            <div class="info">
                <div class="namePage" v-if="currentPage">
                    {{currentPage.name}}
                </div>
                <div class="typeEvent">
                    <p html>{{ dateFormatPost(event.date*1000) }}</p>
               
                    <template v-if="post">
                        <p  v-if="post.permalink" class="show-post"><a :href="post.permalink" target="_blank">Voir</a></p>
                    </template>
                </div>
            </div>
            <div class="selectActionEvent">
                <SelectComponent :changeValueSelect="changeStatus" :data="{treated:$t('dash.inbox.state.treated'),waiting:$t('dash.inbox.state.waiting')}" :valueSelect="[1, 3].includes(event.status) ? 'treated' : 'waiting'" :positionY="'bottom'" :positionAuto="false"></SelectComponent>
            </div>
        </div>
        <div class="scrollable">

            <template v-if="post == false" >
                <div class="container-none-post">
                  <div class="none-post">
                    <p>Post non disponible</p>
                  </div>
                </div>
            </template>
            <template v-else-if="isLoading || !post || !Object.keys(post).length">
                <div class="container-content-post loading-content">
                    <div class="content-post">
                        <div class="content">
                            <div class="picture"></div>
                        </div>
                        <div class="bar-action-container">
                            <div class="btns-action">
                                <div class="reaction">
                                    <i class="fa-regular fa-heart"></i>
                                </div>
                                <div class="comments">
                                    <i class="fa-regular fa-comment"></i>
                                </div>
                                
                            </div>
                        
                        </div>
                    </div>
                </div>
                <div class="container-content-comments loading-content">
                    <div class="container-comment" v-for="index in 3" :key="index">                
                        <div class="comment">               
                            <div class="picture-user">
                                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAJElEQVRoge3BAQEAAAjDoPUvfYMItG0BAAAAALwHAAAAwC/VAZFoA/0E7YaAAAAAAElFTkSuQmCC">             
                            </div>
                            <div class="container-content">
                                <div class="content">
                                    <p class="text">{{ 'w'.repeat(5+Math.random()*3) }}</p>               
                                </div>
                                <div class="info-content">
                                    <div class="date">wwwwwwwww</div>
                                    <div class="action">
                                        <div class="answer">Répondre</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="post && Object.keys(post).length">
                <div class="container-content-post">
                    <div class="content-post">
                        <div class="content">
                            <!-- image simple-->
                            <template v-if="post.media_type == 'IMAGE' && post.media_url">
                                <div class="picture loading-content">
                                    <img :src="post.media_url">
                                </div>
                            </template>

                            <!-- video simple -->
                            <template v-if="post.media_type == 'VIDEO' && post.media_url">
                                <div class="video">
                                    <video controls :src="post.media_url"></video>
                                </div>
                            </template>

                            <!-- carousel -->
                            <template v-if="post.media_type == 'CAROUSEL_ALBUM'">
                                <div class="multi-media">

                                    <carousel :perPage="1" :adjustableHeight="true" :centerMode="true">
                                        <Slide v-for="children in post.children.data" :key="children.id">
                                            <svg class="icon-carousel" width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M95.1 78.525V17.75C95.1 8.32498 87.625 0.849976 78.2 0.849976H17.75C8.32498 0.849976 0.849976 8.32498 0.849976 17.75V78.525C0.849976 87.95 8.32498 95.425 17.75 95.425H78.525C87.625 95.1 95.1 87.625 95.1 78.525ZM109.4 30.75V83.075C109.4 97.7 97.375 109.725 82.75 109.725H30.425C28.475 109.725 27.5 112 28.8 113.3C32.05 116.875 36.6 119.15 42.125 119.15H85.675C104.2 119.15 119.15 104.2 119.15 85.675V42.125C119.15 36.925 116.875 32.05 113.3 28.8C111.675 27.5 109.4 28.8 109.4 30.75Z" fill="white"/>
                                            </svg>
                                            <img v-if="children.media_url.split('/')[3] == 'v' || children.media_url.split('/')[3] !== 'o1'" :src="children.media_url">
                                            <video v-else src="children.media_url"></video> <!--controls , retirer car sinon on ne peux pas swipe-->
                                      
                                            
                                
                                        </Slide>
                                    </carousel>
                                </div>
                            </template>

                            <div class="text" v-if="post.caption"><pre v-html="messagePostFormat(post.caption)"></pre></div>                    
                            
                        </div>
                        <div class="bar-action-container">
                            <div class="btns-action">
                                <div class="reaction" @click="toggleLikePost(post.ig_id)" :class="{liked: post.user_likes}">
                                    <i class="fa-regular fa-heart"></i>
                                    {{ post.like_count ? getFormatNumber(post.like_count) : 0}} like{{post.like_count && post.like_count > 1 ? 's' : ''}}
                                </div>
                                <div class="comments" @click="autoFocus = true">
                                    <i class="fa-regular fa-comment"></i>
                                    {{ post.comments_count ? getFormatNumber(post.comments_count) : 0 }} commentaire{{post.comments_count && post.comments_count > 1 ? 's' : ''}}
                                </div>
                                
                            </div>
                        
                        </div>
                    </div>
                </div>
                <div class="container-content-comments">
                    <template v-if="errorLoadOriginalComment">
                        <div class="container-comment">
                            
                            <div class="comment">
                            
                                <div class="picture-user">
                                    <img src="img/avatar.jpg">             
                                </div>
                                <div class="container-content">
                                    <div class="content">
                                        <!-- <p class="name-user"></p> -->
                                        <p class="text"><span class="name-user">{{ event.data.changes && event.data.changes.value && event.data.changes.value.from  && event.data.changes.value.from.username  ? event.data.changes.value.from.username : "" }}</span><br>Commentaire indisponible</p>
                                        <div class="media"></div>

                                        
                                    </div>
                                    <div class="info-content">
                                        <!-- <div class="date">{{ dateFormat(comment.timestamp) }}</div>
                                        <div class="action">
                                            <div class="answer" @click="startResponseComment(comment.id)">Répondre</div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-if="('is_comment_enabled' in post) && !post.is_comment_enabled">
                        <p class="no-comment">Les commentaires sont désactivé</p>
                    </template>
                    <template v-else-if="post.comments && post.comments.data && post.comments.data.length">
                        <div class="container-comment" v-for="(comment,indexComment) in post.comments.data" :key="comment.id">
                            
                            <div class="comment" :class="{'has-response' : comment.replies && comment.replies.data && comment.replies.data.length, 'hidden':comment.is_hidden}">
                            
                                <div class="picture-user">
                                    <img src="img/avatar.jpg">             
                                </div>
                                <div class="container-content">
                                    <div class="content">
                                        <!-- <p class="name-user"></p> -->
                                        <p class="text"><span class="name-user">{{ comment.from && comment.from.username  ? comment.from.username : comment.username }}</span> {{ comment.text }}</p>
                                        <div class="media"></div>

                                        <ContextMenu :options="getOptionComment(comment.id, comment) " :id="comment.id" v-on:clickOption="clickOptionComment">
                                            <div class="btn-more"></div>
                                        </ContextMenu>
                                        
                                    </div>
                                    <div class="info-content">
                                        <div class="date">{{ dateFormat(comment.timestamp) }}</div>
                                        <div class="action">
                                            <div class="answer" @click="startResponseComment(comment.id)">Répondre</div>
                                            <!-- <div class="private-message" v-if="!comment.from || comment.from.id !== page.network_id" @click="startPrivateMessage(comment.id, comment.from && comment.from.username ? comment.from.username : comment.username)">Message privé</div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <template v-if="comment.replies && comment.replies.data && comment.replies.data.length">
                                <div v-for="(subComment,index) in comment.replies.data" :key="index" class="comment response" :class="{'hidden':subComment.is_hidden}">
                                    <div class="picture-user"> 
                                        <img src="img/avatar.jpg">
                                    </div>
                                    <div class="container-content">
                                        <div class="content">
                                            <!-- <p class="name-user"></p> -->
                                            <p class="text"><span class="name-user">{{ subComment.username || (subComment.from && subComment.from.username) }}</span> {{ subComment.text }}</p>
                                            <div class="media"></div>

                                            <ContextMenu :options="getOptionComment(subComment.id, subComment) " :id="subComment.id" v-on:clickOption="clickOptionComment">
                                                <div class="btn-more"></div>
                                            </ContextMenu>
                                        </div>
                                        <div class="info-content">
                                            <div class="date">{{ dateFormat(subComment.timestamp) }}</div>
                                            <div class="action">
                                                <!-- <div class="answer" @click="startResponseComment(subComment.id)"">Répondre</div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="comment.replies && comment.replies.paging && comment.replies.paging.next">     
                                    <div class="comment response end">
                                        
                                        <div class="container-content">
                                            <span class="more-comment"><p @click="getNextResponseComment(indexComment)">Voir plus réponses</p><div v-if="comment.displayloaderNextComment" class="util-loader"></div></span>
                                        </div>
                                    </div>
                            </template>
                        </div>
                        <span v-if="post.comments.paging && post.comments.paging.next" class="more-comment" @click="getNextComment"><p>Voir plus de commentaires</p><div v-if="displayloaderNextComment" class="util-loader"></div></span>
                    </template>
                    <template v-else-if="post.comments_count && post.comments_count > 0">
                        <p class="no-comment">Commentaire indisponible</p>
                    </template>
                    <template v-else>
                        <p class="no-comment">Aucun commentaire</p>
                    </template>

                    
                </div>
            </template>

           
        </div>
        <FormSendMessage v-on:onSubmitMessage="sendComment" :activeMedia="false" :setAutofocus="autoFocus" @autoFocused="autoFocus = false" ></FormSendMessage>
        <div class="container-response-comment" v-if="responseComment">
            <p>Répondre à <span>{{getCommentById(responseComment) ? getCommentById(responseComment).from.username : 'rien'}}</span></p>
            <i class="fa-solid fa-circle-xmark" @click="stopResponseComment"></i>
        </div>
        <div class="container-response-comment container-private-message" v-if="privateMessageComment">
            <p>Message privé à <span>{{ privateMessageComment.name }}</span></p>
            <i class="fa-solid fa-circle-xmark" @click="stopPrivateMessage"></i>
        </div>
    </div>
</template>

<script>
    import mixinModeration from './../../mixins/Moderation.vue'
    import ContextMenu from './../contextMenu/contextMenuInit.vue'
    import FormSendMessage from './FormSendMessage'
    import AvatarComponent from './../utils/avatar.vue'
    import SelectComponent from './../utils/select.vue'
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        name: 'component-post-instagram',

        components: {
            FormSendMessage,
            ContextMenu,
            AvatarComponent,
            SelectComponent,
            Carousel,
            Slide
        },

        mixins: [mixinModeration],

        props: {
            page: Object,
            post: Object,
            event: Object,
            isLoading : {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                responseComment: false,
                privateMessageComment: false,
                idParentOriginalComment : null,
                displayloaderNextComment : false,
                errorLoadOriginalComment : false,
                currentPage: null,
                autoFocus: false,
            }
        },

        mounted () {
   
        },

        methods: {
            changeStatus(status){
                this.$emit('changeStatus', status)
            },

            // Un commentaire supprimé peut être le sujet de son propre event dans l'inbox
            // (une autre notification, indépendante de celle affichée ici) : si on le trouve,
            // on le marque supprimé aussi plutôt que de le laisser trainer en attente.
            async markCommentEventDeleted(objectId) {
                try {
                    let res = await this.getInboxEvent(this.page.id, objectId)
                    if (res && res.body && res.body.event && res.body.event._id)
                        await this.postInboxEvent(res.body.event._id, this.page, { status: 4 })
                } catch (e) {
                    console.error('markCommentEventDeleted failed', e)
                }
            },

            getFormatNumber(number) {
                const absNumber = Math.abs(number);
                const fixed = function(value){
                    return value % 1 === 0 ? value.toFixed(0) : value.toFixed(1);
                }

                if (absNumber >= 1e9) {
                    return fixed(number / 1e9) + ' MD';
                } else if (absNumber >= 1e6) {
                    return fixed(number / 1e6) + ' M';
                } else if (absNumber >= 1e3) {
                    return fixed(number / 1e3) + ' K';
                } else {
                    return number.toString();
                }
                
            },

            dateFormat(dateComment) {
                if (typeof dateComment !== "object") {
                    dateComment = new Date(dateComment)
                }

                let date = new Date()
                const diffInMilliseconds = Math.abs(date - dateComment);
                const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
                const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
                const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
                const diffInWeeks = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24 * 7));
                const diffInYears = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24 * 365));

                if (diffInYears > 0) {
                    return diffInYears + (diffInYears === 1 ? ' an' : ' ans');
                } else if (diffInWeeks > 0) {
                    return diffInWeeks + 'sem';
                } else if (diffInDays > 0) {
                    return diffInDays + 'j';
                } else if (diffInHours > 0) {
                    return diffInHours + 'h';
                } else {
                    return diffInMinutes + 'min';
                }
            },

            dateFormatPost(dateMessage) {
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
                    return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return "Le "+dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
                }
            },

            messagePostFormat(text) {
                // Ajouter un espace devant les https/http si aucun espace n'est présent juste avant
                // Ajouter un espace devant les www si aucun // ou espace n'est présent juste avant
                text = text.replace(/(?<!\s)(https?:\/\/)|(?<!\/\/|[^\/]\s)(www\.)/g, " $1$2") // eslint-disable-line
           
                var replacedText, replacePattern1, replacePattern2, replacePattern3;
                //URLs starting with http://, https://, or ftp://
                replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim; // eslint-disable-line
                replacedText = text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

                //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
                replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim; // eslint-disable-line
                replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

                //Change email addresses to mailto:: links.
                replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim; // eslint-disable-line
                replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>'); // eslint-disable-line

                return replacedText.trim();
            },

            have_liked_comment(nodeId){

                try {
                    this.post.comment.likes.data.find(liker => liker.id == this.page.network_id) 
                } catch (error) {
                    return false
                }
         
            
            },

            startResponseComment(commentId) {
                this.responseComment = commentId
                this.privateMessageComment = false
            },

            stopResponseComment() {
                this.responseComment = false
            },

            startPrivateMessage(commentId, name) {
                this.privateMessageComment = { id: commentId, name }
                this.responseComment = false
                this.autoFocus = true
            },

            stopPrivateMessage() {
                this.privateMessageComment = false
            },

            getCommentById(commentId,returnNode = false) {
                if (this.post.comments && this.post.comments.data) {
                    for (const comment of this.post.comments.data) {
                        if (comment.id == commentId) {
                            return returnNode ? this.post.comments : comment;
                        } else if (comment.replies && comment.replies.data) {
                            for (const subComment of comment.replies.data) {
                                if (subComment.id == commentId) {
                                    return returnNode ? comment.replies : subComment;
                                }
                            }
                        }
                    }
                }
                return false;
            },
            
            async toggleLikeComment(nodeId) {
                let comment = this.getCommentById(nodeId) 
                console.log("toggleLikeComment",comment)
                const toggleFlagLike = (comment)=>{
                    comment.user_likes = comment.user_likes ? !comment.user_likes : true
                    return comment.user_likes 
                }

                const flagLike = toggleFlagLike(comment)
                if (flagLike !== undefined) {
                    let res = await this.likeNode(this.page, nodeId)
       
                    const { success, error } = res.body
                    console.log(comment)
                    if (!success || success !== true) {
                        toggleFlagLike(comment)
                        return false
                    }

                    return true
                    
                }
            },

            async toggleLikePost(nodeId) {
                const wasLiked = !!this.post.user_likes
                const previousCount = this.post.like_count

                this.$set(this.post, 'user_likes', !wasLiked)
                this.$set(this.post, 'like_count', (previousCount || 0) + (wasLiked ? -1 : 1))

                let res = await this.likeNode(this.page, nodeId, null, wasLiked, 'media')

                const { success, error } = res.body

                if (!success || success !== true) {
                    this.$set(this.post, 'user_likes', wasLiked)
                    this.$set(this.post, 'like_count', previousCount)
                    return false
                }

                return true
            },
    
            async sendComment(formData,filesUrl = []) {
                if (this.post && formData.get('message')) {

                    if (this.privateMessageComment) {
                        const res = await this.sendPrivateReply(this.page, this.privateMessageComment.id, formData.get('message'))
                        if (!res.body || !res.body.success) {
                            const errorKey = res.body && res.body.error
                            this.$vs.notify({
                                title: this.$t('onboarding.2fa.error_title'),
                                text: errorKey === 'dash.error.send-private-message-failed'
                                    ? this.$t('dash.error.send-private-message-failed')
                                    : this.$t('dash.error.send-private-message-failed-generic'),
                                color: 'danger',
                                time: 10000
                            })
                            return
                        }
                        this.stopPrivateMessage()
                        return
                    }

                    if (this.responseComment) {
                        
                        const commentTarget = this.getCommentById(this.responseComment)
                
                        if (commentTarget) {
                            
                            if (!commentTarget.replies || !commentTarget.replies.data) {
                             
                                await this.$set(commentTarget,'replies', {
                                    data : [

                                    ]
                                })
                            }
                        
                            commentTarget.replies.data = [{
                                //can_hide: false,
                                comment_count: 0,
                                timestamp: new Date().toISOString(),
                                from: {"username":this.page.name, id: this.page.network_id},
                                id: "",
                                is_hidden: false,
                                like_count: 0,
                                text: formData.get('message'),
                            }, ...commentTarget.replies.data]
                            
                            let res = await this.addComment(this.page, commentTarget.id, formData.get('message'),this.post.media_id)
                            const { success, comment } = res.body

                            if (!success || success !== true) {
                                commentTarget.replies.data.pop()
                                return
                            }
                                
                        }
                                        
                        this.stopResponseComment()
                    }else{
                        if (!this.post.comments || !this.post.comments.data) {
                            this.post.comments = {
                                data : [
                                    
                                ],
                            }
                        }
                        
                        this.post.comments.data = [...this.post.comments.data, {
                            //can_hide: false,
                            comment_count: 0,
                            timestamp: new Date().toISOString(),
                            from: {"username":this.page.name, id: this.post.ig_id},
                            id: "",
                            is_hidden: false,
                            like_count: 0,
                            text: formData.get('message'),
                            user_likes: false,
                        }]
                        

                        let res = await this.addComment(this.page, this.event.data.changes.value.media.id, formData.get('message'))
                        const { success, comment } = res.body

                        if (!success || success !== true) {
                            this.post.comments.data.pop()
                            return
                        } 
                    }    
                    
                }
            },

            async clickOptionComment(id, nameOption) {
                console.log("clickOptionComment ",nameOption)
            
                switch (nameOption) {
                    case 'deleteComment': {
                        //save parent
                        let isOriginalComment = id == this.idParentOriginalComment
                        let nodeComment = this.getCommentById(id,true)
                        console.log("deleteComment",nodeComment)
                        if (nodeComment) {
                            let saveNodeComment = Object.assign({}, nodeComment);
                            nodeComment.data = nodeComment.data.filter((comment) => comment.id !== id)

                            let res = await this.deleteNode(this.page, id)
                            let { success, error } = res.body;
                            console.log(success, error)
                            if (!success || success !== true) {
                                nodeComment = saveNodeComment
                            }
                            else if (isOriginalComment) {
                                this.$emit('deleteComment', this.event._id)
                            }
                            else {
                                this.markCommentEventDeleted(id)
                            }
                        }
                
                        break;
                    }

                    case 'hideComment': {
                        let commentHide = this.getCommentById(id)
                        commentHide.is_hidden = false
                        let resHideComment = await this.hideNode(this.page, this.event.object_id, true)  //true, incoherence du server (ça devrait etre true) 
                        let { success: hideSuccess, error: hideError } = resHideComment.body;
                      
                        if (!hideSuccess || hideSuccess !== true) {
                            commentHide.is_hidden = false
                        }
                        break;
                    }   
                  
                    case 'evaluateComment': {
                    
                        break;
                    }
              
                }
            },

            getOptionComment(idComment, comment) {
                // if (!comment) {
                //     comment = this.getCommentById(idComment)
                // }

                let options = [{label: this.$t('dash.button.delete'), name : 'deleteComment'}]
                //,{label: this.$t('dash.inbox.filter.evaluate'), name : 'evaluateComment'}

                // if (comment.is_hidden) {
                //     options = [{label: this.$t('dash.inbox.state.unhide'), name : 'showComment'},...options]
                // }else{
                //     options = [{label: this.$t('dash.pages.group.hide'), name : 'hideComment'},...options]
                // }
        
                return options



            },
            async getOriginalComment() {
                console.log('getOriginalComment start')
                this.errorLoadOriginalComment = false
                if (this.post && this.post.comments && this.post.comments.data) {
                    this.idParentOriginalComment = this.event.data.changes.value.parent_id && this.event.data.changes.value.parent_id !== this.event.data.changes.value.id ? this.event.data.changes.value.parent_id : this.event.data.changes.value.id
                    console.log('getOriginalComment start2')
                    let res = await this.getCommentPost(this.page, this.event.data.changes.value.post_id, this.idParentOriginalComment)
                    const { success, error, comment } = res.body
                    if (success && comment ) {
                        this.post.comments.data = [{
                            ...comment,
                            originalComment : this.event.data.changes.value.parent_id === this.event.data.changes.value.post_id,
                        },...((this.post.comments && this.post.comments.data) || []).filter(c => c.id !== this.idParentOriginalComment)]

                        //si c'est une reponse
                        console.log('-------clem-----', comment,this.event.data.changes.value.parent_id  && this.event.data.changes.value.parent_id !== this.event.data.changes.value.id)
                        if (this.event.data.changes.value.parent_id  && this.event.data.changes.value.parent_id !== this.event.data.changes.value.id) {
                            console.log([
                                {
                                    ...this.event.data.changes.value,
                                    id : this.event.data.changes.value.id,
                                    // timestamp : this.event.detail.timestamp,
                                    originalComment : true
                                },
                                ...(this.post.comments.data[0].replies.data.filter(c=> c.id !== this.event.data.changes.value.id))
                            ])
                            this.post.comments.data[0].replies.data = [
                                {
                                    ...this.event.data.changes.value,
                                    id : this.event.data.changes.value.id,
                                    timestamp : this.event.detail ? this.event.detail.timestamp : this.event.date,
                                    originalComment : true
                                },
                                ...(this.post.comments.data[0].replies.data.filter(c=> c.id !== this.event.data.changes.value.id))
                            ]
                        }
                    }else{
                        this.errorLoadOriginalComment = true
                    }
                    
                }
                console.log('getOriginalComment end')
           
            },

            async getDetailAllComment() {
                console.log('getDetailAllComment')
                if (this.post && this.post.comments &&  this.post.comments.data) {
                    // this.isLoading = true
                    const postId = this.post.id
                    const updatedComments = await Promise.all(this.post.comments.data.map(async (oldComment) => {
                        let res = await this.getCommentPost(this.page, postId, oldComment.id)
                        const { success, error, comment } = res.body
                        console.log(oldComment,success,comment)
                        if (!success || success !== true || !comment) {
                            return oldComment
                        }
                        return comment
                    }))

                    // this.post can be swapped/cleared while the requests above are in flight
                    if (this.post && this.post.id === postId && this.post.comments) {
                        this.post.comments.data = updatedComments
                    }
                }
            },
            
            async getNextComment() {
                
                if (this.post.comments.paging.next) {
                    this.displayloaderNextComment = true
                    let request = await this.$http.get(this.post.comments.paging.next, {}).then(res => res, err => err);
                
                    if (request.body && request.body.data) {
                       

                        request.body.data = await Promise.all(request.body.data.map(async (oldComment) => {
                            let res = await this.getCommentPost(this.page, this.post.id, oldComment.id)
                            const { success, error, comment } = res.body
                            console.log(oldComment,success,comment)
                            if (!success || success !== true || !comment) {
                                return oldComment
                            }
                            return comment
                        }))

                        let newArray = (this.post.comments.data).concat(request.body.data)
                        if (request.body.paging) {
                            this.post.comments.paging = request.body.paging
                        }else{
                            this.post.comments.paging = false
                        }
                        this.post.comments.data = newArray
                    }
                    this.displayloaderNextComment = false
                }
            },

            async getNextResponseComment(indexComment) {
                if (this.post.comments && this.post.comments.data && this.post.comments.data[indexComment]  && this.post.comments.data[indexComment].replies && this.post.comments.data[indexComment].replies.paging && this.post.comments.data[indexComment].replies.paging.next) {
                    
                    this.$set(this.post.comments.data[indexComment], 'displayloaderNextComment', true)
                    let request = await this.$http.get(this.post.comments.data[indexComment].replies.paging.next, {}).then(res => res, err => err);
                  
                    if (request.body && request.body.data) {

                        if (this.idParentOriginalComment == this.post.comments.data[indexComment].id) {
                            request.body.data = request.body.data.filter(c=> c.id !== this.event.data.changes.value.id) //retire le commentaire de l'evenement car deja inserer
                        }

                        let newArray = (this.post.comments.data[indexComment].replies.data).concat(request.body.data)

                        if (request.body.paging) {
                            this.post.comments.data[indexComment].replies.paging = request.body.paging
                        }else{
                            this.post.comments.data[indexComment].replies.paging = false
                        }
                        this.post.comments.data[indexComment].replies.data = newArray
                    }
                    this.post.comments.data[indexComment].displayloaderNextComment = false
                }
            }
        },

        watch: {
            async post() {      
                // this.isLoading = true
                if (this.post && Object.keys(this.post).length) {
                    console.log('watch post2')
                    await this.getDetailAllComment();
                    await this.getOriginalComment();
                }     
                // this.isLoading = false    
                
                this.currentPage = this.page
                if(this.event.type == 'mention' && this.event.detail && this.event.detail.mentioned_comment && !this.event.detail.mentioned_comment.media.owner && this.event.detail.mentioned_comment.media.username) {
                    this.currentPage = {
                        avatar: null,
                        name: this.event.detail.mentioned_comment.media.username,
                        network: 'instagram',
                    }
                } 
                else if(this.event.type == 'mention' && this.event.detail && this.event.detail.mentioned_media && this.event.detail.mentioned_media.username) {
                    this.currentPage = {
                        avatar: null,
                        name: this.event.detail.mentioned_media.username,
                        network: 'instagram',
                    }
                } 
            }
        }
    }
</script>







                

